// extracted by css-extract-rspack-plugin
export default {"AddAggregationButtonRoot":"AddAggregationButton-module__AddAggregationButtonRoot___zwcLI"};